import { PointsFeatureCollection } from '@lidea/shared/util/types';
import type { Map as MapboxMap } from 'mapbox-gl';

/** Screen-space radius for tapping a zoning point on mobile (visual dot stays 25px). */
export const MOBILE_POINT_HIT_RADIUS_PX = 40;

export function findNearestPointId(
  map: MapboxMap,
  points: PointsFeatureCollection,
  clickPoint: { x: number; y: number },
  maxDistancePx: number
): number | null {
  let nearestId: number | null = null;
  let minDistance = maxDistancePx;

  for (const feature of points.features) {
    const [lng, lat] = feature.geometry.coordinates;
    const projected = map.project([lng, lat]);
    const distance = Math.hypot(
      projected.x - clickPoint.x,
      projected.y - clickPoint.y
    );

    if (distance <= minDistance) {
      minDistance = distance;
      nearestId = feature.id;
    }
  }

  return nearestId;
}
